import React from 'react';
import { Col } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';

const ReusableRecentNews = () => {
  return (
    <>
      <Col lg={4} xs={12} sm={6}>
        <Card className="recent_news_main">
          <div className="recent_img">
            <Card.Img variant="top" src="imeges/desktop 9/News_background.svg" />
            <img className="veg_logo" src="imeges/desktop 9/veg-logo.svg" alt="" />
          </div>
          <Card.Body className="recent_text">
            <Card.Title> <h3>Green Onion Knife and <br/>salad placed</h3></Card.Title>
            <Card.Text>
            <p>Nulla quis lorem ut libero malesuada feugiat. Nulla quis lorem ut libero malesuada feugiat. </p>
            </Card.Text>
          </Card.Body>
          <Card.Body className="recent_text">
            <Card.Link href="#">read more <i className="fas fa-arrow-right"></i></Card.Link>
          </Card.Body>
        </Card>
      </Col>
    </>
  );
};

export default ReusableRecentNews;

